import { type KeyboardEvent as ReactKeyboardEvent } from 'react';
import { useIntl } from 'react-intl';

import { DownloadIcon } from '@dynatrace/strato-icons';

import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { useA11yToolbarTabIndex } from '../../../core/hooks/useA11yToolbarTabIndex.js';
import { useHistogramFilteredData } from '../../hooks/useHistogramFilteredData.js';
import { useHistogramToolbar } from '../../hooks/useHistogramToolbar.js';
import { HISTOGRAM_MESSAGES } from '../../messages/tooltip-text.js';
import { buildAndDownloadCsv } from '../../utils/build-and-download-csv.js';

export const DownloadDataButton = () => {
  const intl = useIntl();
  const { downloadData } = useHistogramToolbar();

  const { series } = useHistogramFilteredData();
  const tabIndex = useA11yToolbarTabIndex('download');

  const handleKeyDown = (event: ReactKeyboardEvent) => {
    if (event.key === 'Enter') {
      buildAndDownloadCsv(series);
    }
  };

  const handleClick = () => {
    buildAndDownloadCsv(series);
  };

  return downloadData?.enabled ? (
    <ChartToolbarRenderer.Control
      prefixIcon={<DownloadIcon />}
      tooltipText={intl.formatMessage(HISTOGRAM_MESSAGES.downloadAsCsv)}
      testId="chart-toolbar-download"
      onKeyDown={handleKeyDown}
      onClick={handleClick}
      tabIndex={tabIndex}
      divider="left"
    />
  ) : null;
};

DownloadDataButton['displayName'] = 'DownloadDataButton';
